import { render, staticRenderFns } from "./ReportColumns.vue?vue&type=template&id=1502ad35&"
import script from "./ReportColumns.vue?vue&type=script&lang=js&"
export * from "./ReportColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports